import React, { useContext  ,useEffect ,useState} from "react";
import "./LandingGrid.css";
import { Col, Container, Row } from "react-bootstrap";
import { LandingContext } from "./LandingContext";
import constValues from "../../constants/constantValues.json";
import { store } from "../../contexts/store";
import HomeCard from "../HomeCard";
//import HomeData from "../../constants/HomeData";
//import useHomeData from "../../constants/HomeData";
import Icons from "../../components/Icons"
import Routes from "../../constants/routes.json"
import api from "../../Api/api"
import { YEAR_RANGE } from "../../contexts/types"
const LandingGrids = () => {
  const LandingModel = useContext(LandingContext);
  const globalState = useContext(store);
  // const HomeData = useHomeData();
  const { dispatch } = globalState;
  const assignValue = (currentItem) => {
    const notificationString = HomeData?.[constValues.FIRST_VALUE_INDEX]?.item;
    if (currentItem === notificationString)
      return LandingModel.notificationCount;
  };
  const [yearRangeValue, setYearRangeValue] = React.useState("");
  const [HomeData ,setHomeData] = React.useState([])
    const [currentYear, setCurrentYear] = useState("");
    const [yearRange, setYearRange] = useState("");
    useEffect(() => {
    const getCurrentElectionYear = async () => {
      try {
        const response = await api.getCurrentElectionYear();
        setCurrentYear(response.data.data.electionYear);
        setYearRange(response.data.data.yearRange);
         dispatch({ type: YEAR_RANGE, payload: response.data.data.yearRange });

 const HomeDataTemp = [
    {
      id: "homeCard-1",
      item: "Notifications",
      location: Routes.NOTIFICATIONS,
      icon: Icons.notification,
    },
    {
      id: "homeCard-2",
      item: "Nominations",
      location: Routes.NOMINATIONS,
      icon: Icons.nominations,
    },
    {
      id: "homeCard-3",
      item: "Candidate List",
      location: Routes.CANDIDATELIST,
      icon: Icons.candidateList,
    },
    {
      id: "homeCard-4",
      item: "Voting",
      location: Routes.VOTING,
      icon: Icons.voting,
    },
    {
      id: "homeCard-5",
      item: "Results",
      location: Routes.RESULT,
      icon: Icons.results,
    },
    {
      id: "homeCard-6",
      item: "EC "+response.data.data.yearRange, // ✅ fallback until data arrives
      location: Routes.NEWASSOCIATION,
      icon: Icons.new_association,
    },
  ];
  setHomeData(HomeDataTemp)
  setYearRangeValue("EC "+response.data.data.yearRange);
       
         
      } catch (err) {
        console.log("API Error", err);
      }
    };
    getCurrentElectionYear();
  }, []);

//console.log("yer",yearRangeValue)
  return (
    <section className="middle-wrap pt-5 pb-5">
      <Container>
        <Row className="justify-content-md-center blue-land-btns">
          <Col xs sm="12" md="12" lg="8">
            <Row className="grid-row">
              {HomeData &&
                HomeData?.map((data) => {
                 
                  return (
                    <HomeCard
                      key={data?.id}
                      item={data?.item}
                      location={data?.location}
                      icon={data?.icon}
                      value={assignValue(data?.item)}
                      condition={constValues?.NOTIFICATION_VALUE_CONDITION}
                      isEnable={
                        data?.item === "Voting"
                          ? globalState.state.voting ||
                            globalState.state.votingEnableCount === 1
                          : data?.item === "Results"
                          ? globalState.state.declareResults ||
                            globalState.state.publishResultEnableCount === 1
                          : data?.item === yearRangeValue //'EC 2025 - 27'//yearRangeValue
                          ? globalState.state.newCommittee ||
                            globalState.state.OnboardNewCommitteeEnableCount ===
                              1
                          : data?.item === "Nominations" ?((globalState.state.submitNominations && globalState.state.user?.isElectionPanel !== "Y")||globalState.state.nominationEnableCount===1 && globalState.state.user && globalState.state.user?.isElectionPanel !== "Y"):
                          (data?.item === "Candidate List"?(globalState.state.publishCandidateList||globalState.state.publishCandidateListEnableCount===1):true)
                      }
                    />
                  );
                })}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default LandingGrids;
